/**
 * rfisApi — AISC §1.7.0 Phase 2.
 */

import ApiCall from './apicall';

export const RFI_STATUSES = ['DRAFT', 'SENT', 'ANSWERED', 'CLOSED', 'CANCELLED'];

const ALLOWED_TRANSITIONS = {
  DRAFT:     ['SENT', 'CANCELLED'],
  SENT:      ['ANSWERED', 'CANCELLED'],
  ANSWERED:  ['CLOSED', 'CANCELLED'],
  CLOSED:    [],
  CANCELLED: [],
};
export const allowedRfiTransitions = (status) => ALLOWED_TRANSITIONS[status] || [];

export async function listRfis(filters = {}) {
  const params = new URLSearchParams();
  if (filters.job_id) params.set('job_id', filters.job_id);
  if (filters.status) params.set('status', filters.status);
  const qs = params.toString();
  const { data } = await ApiCall.get(`/rfi${qs ? `?${qs}` : ''}`);
  return data;
}

export async function getRfi(id) {
  const { data } = await ApiCall.get(`/rfi/${id}`);
  return data;
}

export async function createRfi(payload) {
  const { data } = await ApiCall.post('/rfi', payload);
  return data;
}

export async function updateRfi(id, payload) {
  const { data } = await ApiCall.patch(`/rfi/${id}`, payload);
  return data;
}

export const sendRfi = async (id) => (await ApiCall.post(`/rfi/${id}/send`)).data;
export const answerRfi = async (id, body) => (await ApiCall.post(`/rfi/${id}/answer`, body)).data;
export const closeRfi = async (id, closure_notes) => (await ApiCall.post(`/rfi/${id}/close`, { closure_notes })).data;
export const cancelRfi = async (id, cancellation_reason) => (await ApiCall.post(`/rfi/${id}/cancel`, { cancellation_reason })).data;
